export default {
    name: 'mine/notes',
    path: 'notes',
    component: () => import('./Root.vue')
}